export const resolveDate = (date: Date | string | null, locale: string) => {
  return new Intl.DateTimeFormat(locale?.toUpperCase(), {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  }).format(date ? new Date(date) : new Date());
};

export const formatDuration = (duration: number) => {
  return Math.floor(duration / (60 * 60 * 24)).toString();
};

export const formatPostedOnDate = (text: string | null, date: string) => {
  if (!text) return null;
  return text.replace('$date', date);
};
